import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import updateLocale from 'dayjs/plugin/updateLocale';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);
dayjs.extend(updateLocale);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

dayjs.updateLocale('en', {
    relativeTime: {    
        future: "in %s",
        past: "%s",
        s: '1s',
        ss: "%ds",
        m: "1m",
        mm: "%dm",
        h: "1h",
        hh: "%dh",
        d: "1d",
        dd: function (number: number) {
          if (number >= 11) {
            return `${Math.round(number / 7)}w`
          }
          return `${number}d`;
        },
        M: "4w",
        MM: "%dmo",
        y: "1y",
        yy: "%dy"
    }
});

export const formatDate = (date: string | number | Date | dayjs.Dayjs) => {
    return dayjs(date).format('LLL z');
};

export const formatDateWithoutTimezone = (date: string | number | Date | dayjs.Dayjs) => {
    return dayjs(date).format('LLL');
};

export const formatRelativeTime = (date: string | number | Date | dayjs.Dayjs) => {
    return dayjs(date).fromNow();
};

export default dayjs;